import {app} from "@/app";
import {AbstractShopifyEvent, EventData} from "@/services/pixel/events/shopify/AbstractShopifyEvent";
import {merge} from "@/helpers";

export class AddToCart extends AbstractShopifyEvent {

  /*
   * NOTE:
   *  - eventPayload is a response of POST:/cart/add.js {
   *        orm_type: product
   *        id: <variant_id>
   *  }
   *  - eventPayload.id & eventPayload.variant_id - are the same
   */
  async handle(eventPayload: null|Record<string, any>, eventContext: null|Record<any, any> = null) {
    await super.handle(eventPayload, eventContext);

    app.debug('Pixel: Shopify Event AddToCart: started');
    app.pixel.log.add({type: 'event.shopify', name: 'AddToCart'});

    if(!eventPayload || !eventPayload?.items || !Array.isArray(eventPayload.items) || eventPayload.items.length === 0) {
      app.debug('Pixel: Shopify Event AddToCart: line item(s) are empty', eventPayload, 'warning');
      return;
    }

    eventPayload.items = eventPayload.items.map(shopifyLineItem => app.storage.shopify.cart.getLineItemSimplifiedPayload(shopifyLineItem));

    const payload = eventPayload;

    let context = await this.getEventContext();
    context = merge(context, eventContext ?? {});

    // send
    const data: EventData = {
      event_name: 'AddToCart',
      event_version: 4,
      payload,
      context,
    };

    await this.pushEventAndSendStack(data);
  }

}
